import { Component } from 'react';
import { debounce } from '@optimus-web/common';
import { DebouncedFunction, ScrollSyncProps, ScrollSyncState } from './interfaces';

class ScrollSync extends Component<ScrollSyncProps, ScrollSyncState> {
    static defaultProps = {
        debounced: true,
        debounceTimeout: 16,
    };

    private debouncedSetScrollPositions: DebouncedFunction<HTMLElement>;

    constructor(props: ScrollSyncProps) {
        super(props);
        this.state = {
            scrollLeft: 0,
            scrollTop: 0,
        };
        this.debouncedSetScrollPositions = debounce<HTMLElement>(this.setScrollPositions, this.props.debounceTimeout);
    }

    componentWillUnmount() {
        this.debouncedSetScrollPositions.cancel();
    }

    setScrollPositions = ({ scrollLeft, scrollTop }: HTMLElement) =>
        this.setState({
            scrollLeft,
            scrollTop,
        });

    onScroll = ({ currentTarget }: React.SyntheticEvent<HTMLElement>) => {
        if (this.props.debounced) {
            this.debouncedSetScrollPositions(currentTarget);
        } else {
            this.setScrollPositions(currentTarget);
        }
    };

    render() {
        const { scrollLeft, scrollTop } = this.state;
        const { children } = this.props;

        return children({ onScroll: this.onScroll, scrollLeft, scrollTop });
    }
}

export default ScrollSync;
